import { download } from '@fv/client-core'

import { apiUri } from '@/constants'
import { useAuthenticatedFileDownload } from '@/hooks/useAuthenticatedFileDownload'

export function useDownloadRatesPDF(loadId: string) {
  const fileDownload = useAuthenticatedFileDownload(
    `${apiUri}/documents/${loadId}/rates-pdf`,
  )

  return {
    isFetchingFile: fileDownload.isPending,
    download: async () => {
      const data = await fileDownload.mutateAsync()
      download(data, `${loadId}-rates.pdf`)
    },
  }
}
